import { Link } from "react-router-dom";
import {
  CalendarClock,
  FileDown,
  HardHat,
  Plus,
  Tractor,
  Wallet,
} from "lucide-react";
import { cn } from "@/lib/utils";

const ACTIONS = [
  {
    to: "/daily-entry",
    label: "Daily Entry",
    description: "Log hours & equipment",
    icon: CalendarClock,
    accent: "bg-orange-construction text-navy-deep",
  },
  {
    to: "/workers/new",
    label: "Add Worker",
    description: "Onboard crew member",
    icon: Plus,
    accent: "bg-navy-blueprint text-white",
  },
  {
    to: "/equipment",
    label: "Add Equipment",
    description: "Register asset or rental",
    icon: Tractor,
    accent: "bg-navy-deep text-white",
  },
  {
    to: "/pay-periods",
    label: "Review Pay Period",
    description: "Approve & lock hours",
    icon: Wallet,
    accent: "bg-green-approved/15 text-green-700",
  },
  {
    to: "/exports",
    label: "Export Payroll",
    description: "Generate payroll batch",
    icon: FileDown,
    accent: "bg-amber-warning/15 text-amber-800",
  },
] as const;

export function QuickActions() {
  return (
    <div className="rounded-xl border bg-card-white p-4 shadow-[var(--shadow-card)] sm:p-5">
      <h2 className="text-sm font-semibold uppercase tracking-wider text-muted-foreground">
        Quick actions
      </h2>
      <div className="mt-4 grid gap-2 sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2">
        {ACTIONS.map((action) => (
          <Link
            key={action.to}
            to={action.to}
            className="group flex items-center gap-3 rounded-lg border border-border/60 p-3 transition-colors hover:border-orange-construction/40 hover:bg-bg-light"
          >
            <span
              className={cn(
                "flex h-10 w-10 shrink-0 items-center justify-center rounded-lg",
                action.accent,
              )}
            >
              <action.icon className="h-4 w-4" />
            </span>
            <span>
              <span className="block text-sm font-semibold text-navy-deep group-hover:text-orange-construction">
                {action.label}
              </span>
              <span className="block text-xs text-muted-foreground">{action.description}</span>
            </span>
          </Link>
        ))}
      </div>
      <p className="mt-3 flex items-center gap-1.5 text-xs text-muted-foreground">
        <HardHat className="h-3.5 w-3.5" />
        Built for foremen — tap an action to jump in
      </p>
    </div>
  );
}
